<template>
    <div class="d-none d-md-block" v-if="LoopIndex !== 'last'">
        <div class="btn bg-info  btn-lg" v-on:click="move(  FileId, 'down' )"><i class="fas fa-arrow-right"></i> </div>
    </div>
</template>

<script>
	export default {
		props: [
		'LoopIndex', 'FileId', 'MenuItemId',"BlockId"
		],

		methods: {
            move(FileId, direction) {
                let formData = new FormData();
                formData.append('FileId', FileId);


                axios.post( '/manage/file/move/'+FileId+'/'+this.BlockId, formData )
                    .then(function(data) {
                        console.log(data);
                        window.location.reload(true);
                    }.bind(this)).catch(function(data) {

                    console.log('error', data);
                    alert('f');
                });


            }

        }



	}
</script>


// WEBPACK FOOTER //
// resources/js/components/MoveFileBlock.vue